import { begin, end, pendingTask } from "react-redux-spinner";
import { put } from "redux-saga/effects";

import { deviceId, userAgent } from "@common";
import {
  deviceNotVerified,
  ILoginWithPasswordAction,
  loginSucceded
} from "../user.actions";
import UserService from "../user.service";
import UserFeedback from "../user.feedback";

export function* login({ payload }: ILoginWithPasswordAction) {
  if (payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });

  try {
    const { username, password } = payload;
    const userService = new UserService();

    const { isKnownDevice, refreshToken } = yield userService.loginWithPassword(
      username,
      password,
      deviceId,
      userAgent
    );

    if (!isKnownDevice) {
      yield put(deviceNotVerified());
      yield put({ type: "SPINNER", [pendingTask]: end });
      return;
    }

    const { accessToken } = yield userService.loginWithToken(
      refreshToken,
      deviceId
    );

    localStorage.setItem("accessToken", accessToken);
    const profile = yield userService.getProfile();

    yield put(loginSucceded(profile));
  } catch (error) {
    yield put(loginSucceded(error, UserFeedback.LOGIN_FAILED));
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}

export function* logout() {
  localStorage.removeItem("accessToken");
}
